import moment from 'moment';

const chart = {
  id: 'basic-bar',
};

const plotOptions = {
  bar: {
    horizontal: true,
    distributed: true,
    // dataLabels: {
    //   position: 'bottom'
    // },
    dataLabels: {
      hideOverflowingLabels: false,
    },
    borderRadius: 10,
  },
};

const dataLabels = {
  enabled: true,
  // textAnchor: 'start',
  style: {
    colors: ['#000'],
    // fontSize: '14px',
  },
  formatter (val, opt) {
    if (isNaN(new Date(val[0])) || isNaN(new Date(val[1]))) {
      return '';
    } else {
      return (
        `${moment(new Date(val[0])).format('YYYY/MM')}` +
      ' ~ ' +
      `${moment(new Date(val[1])).format('YYYY/MM')}`
      );
    }
    // return `${opt.w.globals.labels[opt.dataPointIndex]}:  ${val}`;
  },
  // dropShadow: {
  //   enabled: true,
  // },
};

const xaxis = {
  type: 'datetime',
  labels: {
    format: 'yyyy/MM',
    style: {
      fontSize: '14px',
      fontWeight: 400,
    },
    // formatter: seriesName => moment(new Date(seriesName)).format('YYYY/MM'),
  },
};

const yaxis = {
  labels: {
    style: {
      fontSize: '14px',
      fontWeight: 400,
    },
    maxWidth: 500,
  },
};

const tooltip = {
  // y:{format:'yyyy/MM'},
  enabled: true,
  custom (tooltipProps) {
    const dataPointIndex = tooltipProps.dataPointIndex;
    const twoDSeriesX = tooltipProps.ctx.data.twoDSeriesX;
    if (isNaN(new Date(tooltipProps.y1)) || isNaN(new Date(tooltipProps.y2))) {
      return null;
    } else {
      return (
        '<div style="padding:4px" >' +
        '<span>' +
        `${twoDSeriesX[dataPointIndex]}：` +
        `${moment(new Date(tooltipProps.y1)).format('YYYY/MM')}` +
        ' ~ ' +
        `${moment(new Date(tooltipProps.y2)).format('YYYY/MM')}` +
        '</span>' +
        '</div>'
      );
    }
  },
};

const colors = (data = []) => data.map(o => {
  if (o.is_review === '2') return '#B3E9ED';
  else if (o.is_pass) return '#C0E5F4';
  else return '#FFE5E5';
});

export default ({ data = [] }) => ({
  chart,
  plotOptions,
  colors: colors(data),
  dataLabels,
  xaxis,
  yaxis,
  tooltip,
});
